module.exports = __webpack_public_path__ + "img/af.db4f3480.svg";